import React from 'react'
import DefaultLayout from '../components/DefaultLayout'

const Template = ({ children, data }) => {
  return <DefaultLayout data={data} children={children} />
}

export default Template

/* eslint no-undef: off */
export const layoutQuery = graphql`
  query siteZH {
    # meta
    site {
      siteMetadata {
        title
      }
    }
    disclaimer: markdownRemark(
      frontmatter: { language: { eq: "ZH" } }
      fileAbsolutePath: { regex: "/disclaimer/" }
    ) {
      html
    }
    menu_labels: labelsJson(language: { eq: "ZH" }) {
      strings {
        menu_case
        menu_products
        menu_maintenance
        menu_remove_stains
        menu_contact_us
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/zh.js